jQuery( function () {
    initFormValidation();
} );

function shakeFormToShowError() {
    jQuery('.full-page-form form, .basic-form form, .form-shake').addClass('animation-shake').one('animationend', function() {
        jQuery(this).removeClass('animation-shake');
    });
}

function initFormValidation() {
    jQuery( '.phone' ).mask( '+1-999-999-9999' );

    var specialChar = /[.,\/#!$%\^&\*;:{}=\-_`~()@]/;
    jQuery.validator.addMethod( "passwordCheck", function ( value ) {
        return /[A-Z]/.test( value ) // has an uppercase letter
            && specialChar.test( value ) // has a special character
            && /\d/.test( value ) // has a digit
    } );

    jQuery.validator.addMethod("customEmailValidate", function(value, element) {
        var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // '[a-zA-Z0-9._%+-]+': The local part of the email address, which allows letters, numbers, dots, underscores, percent signs, plus signs, and hyphens.
        // '@': The at symbol, separating the local part from the domain.
        // '[a-zA-Z0-9.-]+': The domain name, which allows letters, numbers, dots, and hyphens.
        // '\.': The dot that separates the domain from the top-level domain.
        // '[a-zA-Z]{2,}': The top-level domain (TLD), which must have at least two letters.

        if (emailPattern.test(value)) {
            return true; // The email is valid
        } else {
            return false; // The email is not valid
        }
    }, "Please enter a valid email address.");

    jQuery.validator.addMethod("customTelInputValidation", function(value, element) {
        return jQuery(element).attr('data-valid') === 'true';
    }, "Please enter a valid phone number.");

    jQuery( '.validate.limited' ).validate( {
        onfocusout: function ( element ) {
            jQuery( element ).valid();
        },
        onkeyup: false,
        onclick: false,
        invalidHandler: function() {
            shakeFormToShowError();
        }
    } );

    jQuery( '.custom-validate' ).find( 'input, select' ).focusout( function () {
        customValidateEl( null, this );
    } );

    jQuery('.validate:not(.limited)').each(function() {
        jQuery(this).validate( {
            onfocusout: function ( element ) {
                jQuery( element ).valid();
            },
            onkeyup: false,
            onclick: false,
            rules: {
                password: {
                    minlength: 8,
                    passwordCheck: true
                },
                cPassword: {
                    equalTo: '#password'
                },
                email: {
                    customEmailValidate: true,
                    remote: {
                        url: "/api/account/register/checkUserName",
                        type: "get",
                        data: {
                            username: function () {
                                return $( "#email" ).val();
                            }
                        }
                    }
                },
                code: {
                    minlength: 5,
                    maxlength: 5
                },
                company_phone: {
                    customTelInputValidation: true
                }
            },
            showErrors: function(errorMap, errorList) {
                if (errorList.length > 0) {
                    this.errorList = [errorList[0]];
                }
                this.defaultShowErrors();
            },
            messages: {
                password: {
                    minlength: "*Must have at least 8 characters, a special character, an uppercase letter, and a digit",
                    passwordCheck: "*Must have at least 8 characters, a special character, an uppercase letter, and a digit"
                },
                cPassword: {
                    equalTo: 'Passwords do not match.'
                },
                email: {
                    remote: 'Account already exists with this email. <a href="/login">Login</a> or Call 877-714-5001 for assistance.'
                },
                code: {
                    minlength: "Code must be 5 characters.",
                    maxlength: "Code must be 5 characters."
                },
                company_phone: {
                    required: "Please enter your company phone."
                }
            },
            invalidHandler: function() {
                shakeFormToShowError();
            },
            errorPlacement: function (error, element) {
                let errorHelperClass = element.closest('.error-helper');

                if (errorHelperClass.length) {
                    error.insertAfter(errorHelperClass);
                } else {
                    error.insertAfter(element);
                }
            },
        } );
    });
}

function jQuerySubmitForm( form, onComplete ) {
    var $form = jQuery( form );
    var action = $form.attr( 'action' );
    var data = $form.serialize();
    jQuery.post( action, data, onComplete );
}

window.showLoader = function showLoader() {
    hideLoader();
    jQuery( "#overlay" ).show();
    jQuery( "#loader" ).show();
}

window.hideLoader = function hideLoader() {
    jQuery( ".overlay" ).hide();
    jQuery( ".loader" ).hide();
}

window.doLogin = function doLogin( response ) {
    var obj = JSON.parse( response );

    if ( obj.cookie != undefined )
        docCookies.setItem( "rememberme", obj.cookie, 31536e3, false, false, true );
}

window.validateAndSubmit = function validateAndSubmit( form, redirect, callback ) {
    if ( jQuery( form ).is( 'form' ) ) {
        if ( jQuery( form ).valid() ) {
            showLoader();
            jQuerySubmitForm( form, processResponse );
        }
        return false;
    } else if ( jQuery( form ).is( '.custom-validate' ) ) {
        if ( customValidate( form ) ) {
            showLoader();
            customSubmitForm( form, processResponse )
        }
    }
    function processResponse( response ) {
        hideLoader();

        let processed = false;
        try {
            var obj = JSON.parse( response );

            var callbackReturnValue = true;
            if ( callback !== undefined ) {
                callbackReturnValue = callback( response );
                processed = true
            }

            //If callback did not cancel the rest of the process by returning false
            if( callbackReturnValue !== false ) {
                if (obj.code == 200) {
                    if (redirect !== undefined && redirect !== false) {
                        showLoader();
                        window.location.href = redirect;
                    }
                } else {
                    jQuery('#errors').html(obj.msg);
                    shakeFormToShowError();
                }
            }
        } catch ( e ) {
            if ( callback !== undefined && !processed)
                callback( false );
        }
    }

    function customValidate( form ) {
        var ret = true;
        jQuery( form ).find( "input, select, textarea" ).each( function ( index, element ) {
            ret &= customValidateEl( index, element );
        } );
        return ret;
    }

    function customSubmitForm( form, callback ) {
        var data = {};
        jQuery( form ).find( "input, select, textarea" ).each( function () {
            var name = jQuery( this ).attr( 'name' );
            data[name] = jQuery( this ).val();
        } );

        function postData( data, callback ) {
            var target = jQuery( form ).data( 'target' );
            jQuery.ajax( {
                method: "POST",
                url: target,
                data: data
            } ).done( callback );
        }

        if ( jQuery( form ).is( '.captcha-protected' )) {
            grecaptcha.ready(function() {
                grecaptcha.execute(window.captchaSiteKey, {action: form.replace(/[^a-zA-Z]/g, "")}).then(function(token) {
                    data.captchaToken = token;
                    postData( data, callback );
                });
            });
        } else {
            postData( data, callback );
        }
    }
}

function customValidateEl( index, element ) {
    var ret = true;
    element = jQuery( element );
    if ( element.attr( 'required' ) && element.val() == '' )
        error( element, element.data( 'msg-required' ) );
    else if ( element.attr( 'name' ) == 'email' && !isValidEmail( element.val() ) )
        error( element, "Please enter a valid email address." );
    else {
        element.siblings( '.error' ).html( '' );
        element.removeClass( 'error' );
    }
    return ret;

    function error( $this, error ) {
        ret = false;
        $this.siblings( '.error' ).html( error );
        $this.addClass( 'error' );
    }
}

function isValidEmail( email ) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test( email );
}

window.configureSubmit = function configureSubmit( form, callback ) {
    var $form = jQuery( form );
    $form.find( 'input,select' ).keydown( function ( e ) {
        var $this = jQuery( this );
        var $parent = $this.closest( form );
        if ( e.keyCode == 13 ) {
            e.preventDefault();
            var $focusable = $parent.find( 'input:not(.no-tab),select,textarea,.submit' ).filter( ':visible' );
            var $next = $focusable.eq( $focusable.index( this ) + 1 );
            if ( $next.length ) {
                $next.focus();
                if ($next.hasClass('submit')) {
                    callback();
                }
            } else {
                callback();
            }
            return false;
        }
    } );
    $form.find( '.submit' ).click( function ( e ) {
        e.preventDefault();
        callback();
    } ).keydown( function ( e ) {
        if ( e.keyCode == 13 ) {
            e.preventDefault();
            callback();
        }
    } );
}

/**
 * Requests a new code for the given MFA method, returning any errors in onComplete or null if successful
 *
 * @param mfaMethod the channel to request a code from (SMS, Email)
 * @param onComplete called with any errors during execution, or null if successful
 */
window.sendMfaCode = function sendMfaCode( mfaMethod, onComplete) {
    fetch('/api/v1/mfa/request-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ method: mfaMethod }),
    })
        .then(res => res.json())
        .then(response => {
            if (response.code === 200) {
                onComplete(null)
            } else {
                onComplete(response.msg !== null && response.msg !== undefined ? response.msg : "Failed to request code from API")
            }
        })
        .catch(err => onComplete(err.msg !== null && err.msg !== undefined ? err.msg : "Error during request code"));
}

$(function() {
    $(".nav .hamburger").click(function() {
        $(".mobile-nav-popout").removeClass("hidden");
    });

    $(".nav .mobile-nav-popout .close-button").click(function() {
        $(".mobile-nav-popout").addClass("hidden");
    });

    $("section.notification button").click(function() {
        $(this).closest("section.notification").slideUp(100);
    });

    $("section.testimonials .slider").slick({
        dots: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: ".prev-button",
        nextArrow: ".next-button",
        dotsClass: "custom-dots",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    })

    $('.logo-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 3000,
        slidesToShow: 7,
        slidesToScroll: 7,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    autoplaySpeed: 5000,
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            },
            {
                breakpoint: 768,
                settings: {
                    autoplaySpeed: 2000,
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    autoplaySpeed: 1200,
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    autoplaySpeed: 1000,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    window.addEventListener('DOMContentLoaded', () => {
        handlePageLoadWithHash();
    });

    window.addEventListener('popstate', () => {
        handlePageLoadWithHash();
    });

    function handlePageLoadWithHash() {
        const hash = window.location.hash.substring(1);

        if (hash) {
           openHashAccordionContainer(hash);
        }
    }

    function openHashAccordionContainer(targetId) {
        const accordionElement = document.getElementById(targetId);
        if (accordionElement && accordionElement.classList.contains('accordion')) {
            accordionElement.classList.toggle('active');
                let siblingElement = accordionElement.nextElementSibling;
                siblingElement.style.display = "block";
        }
    }

    // script to toggle accordion open/closed
    var acc = document.querySelectorAll(".documents-accordion .accordion");
    if (acc) {
        var i;
        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
//        this.classList.toggle("active");
                var apanel = this.nextElementSibling;
                if (apanel.style.display === "block") {
                    apanel.style.display = "none";
                } else {
                    var active = document.querySelectorAll(".documents-accordion .accordion.active");
                    for (var j = 0; j < active.length; j++) {
                        active[j].classList.remove("active");
                        active[j].nextElementSibling.style.display = "none";
                    }

                    apanel.style.display = "block";
                }
                this.classList.toggle("active");

            });
        }
    }
        jQuery('#productsOption').click(function(event) {
            event.stopPropagation();
            jQuery('.nav-dropdown-products').show();
        });
        jQuery(document).click(function(event) {
            if (!jQuery(event.target).closest('#productsOption').length) {
                jQuery('.nav-dropdown-products').hide();
            }
        });
        jQuery('.nav-dropdown-products').blur(function(){
            jQuery('.nav-dropdown-products').hide();
        });
        jQuery('.nav-dropdown-products').click(function(event){
            event.stopPropagation();
        });
        jQuery('.mobile-nav-popout .nav-link').click(function(event) {
        if (jQuery(this).text() === "Products") {
            event.preventDefault();
            event.stopPropagation();
            jQuery('.mobile-nav-dropdown-products').show();
         }
        });
        jQuery(document).click(function(event) {
        if (!jQuery(event.target).closest('.mobile-nav-dropdown-products').length) {
            jQuery('.mobile-nav-dropdown-products').hide();
             }
         });
         jQuery('.mobile-nav-dropdown-products').click(function(event){
                event.stopPropagation();
         });
        jQuery('.close-button-products').click(function() {
            jQuery('.mobile-nav-dropdown-products').hide();
        });
        jQuery('.row-option ').click(function(){
            jQuery('.nav-dropdown-products').hide();
            jQuery('.mobile-nav-popout').hide();
        })
        jQuery('.dropdown-option').click(function(){
            jQuery('.nav-dropdown-products').hide();
        })
})